// @ts-strict-ignore
import {Component, DoCheck, Injector, OnChanges, SimpleChanges} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import Enumerable from "linq";
import {SimUtilityService} from "@services";
import {Router} from "@angular/router";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {Translations} from "@translations";

export interface DialogData_RecorderInitializationDialog extends MatDialogDataBaseInput {
	tasks: InitializationTask[];
}

export interface InitializationTask {
	name: string;
	weight: number;
	order: number;
	success?: boolean;
}

@Component({
	selector: "sim-recorder-initialization-dialog",
	templateUrl: "./recorder-initialization-dialog.component.html",
	styleUrls: ["./recorder-initialization-dialog.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class RecorderInitializationDialogComponent
	extends BasicMaterialDialog<RecorderInitializationDialogComponent, DialogData_RecorderInitializationDialog, MatDialogDataBaseOutput>
	implements DoCheck, OnChanges
{
	T = Translations;

	public totalWeight = 0;
	public currentMessage = "";
	public failed: boolean = false;

	constructor(
		_injector: Injector,
		private _router: Router,
	) {
		super(_injector);
		this.totalWeight = this.getTotalWeight();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.totalWeight = this.getTotalWeight();
	}

	async ngDoCheck() {
		const tasks = Enumerable.from(this.data.tasks);
		const failed = tasks.any((task) => task.success == false);
		const success = !failed && tasks.all((task) => task.success);
		if (success) {
			await SimUtilityService.delay(200);
			this.close();
		} else if (failed) {
			this.failed = true;
		}
	}

	private getTotalWeight() {
		return Enumerable.from(this.data.tasks).sum((task) => task.weight);
	}

	getProgress() {
		const sumWeights = Enumerable.from(this.data.tasks)
			.where((task) => task.success)
			.sum((task) => task.weight);

		const initializeProgress = (sumWeights / this.totalWeight) * 100;
		return initializeProgress;
	}

	reload() {
		window.location.reload();
	}

	async toDashboard() {
		await this._router.navigateByUrl("");
		this.close();
	}
}
